import { EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { Subject } from "rxjs";
var CertificateSignatureSidePanelComponent = /** @class */ (function () {
    function CertificateSignatureSidePanelComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.signatureText = '';
        this.base64Image = '';
        this.showSignatureSidePanel = false;
        this.onSignatureGenerate = new EventEmitter();
        this.closeEmitter = new EventEmitter();
        this.screenFor = 0;
    }
    CertificateSignatureSidePanelComponent.prototype.ngOnInit = function () {
        this.onClose = new Subject();
    };
    CertificateSignatureSidePanelComponent.prototype.onSidepanelClose = function () {
        this.bsModalRef.hide();
    };
    CertificateSignatureSidePanelComponent.prototype.getSignature = function (base64Image) {
        this.base64Image = base64Image;
    };
    CertificateSignatureSidePanelComponent.prototype.insertSignature = function () {
        this.onSignatureGenerate.emit(this.base64Image);
        this.signatureText = '';
        this.onClose.next(this.base64Image);
        this.bsModalRef.hide();
    };
    return CertificateSignatureSidePanelComponent;
}());
export { CertificateSignatureSidePanelComponent };
